<script setup lang="ts">
import { TransitionPresets } from '@vueuse/core';
import { ButtonType } from '../types/common';

const props = defineProps<{
    title: string;
    current: number;
    buttonLabel?: string;
    loading?: boolean;
    disabled?: boolean;
}>();

const emit = defineEmits<{
    'action': [];
}>();

const source = ref(0);
const animatedCurrent = useTransition(source, {
    duration: 1000,
    transition: TransitionPresets.easeInOutCubic
});

watch(() => props.current, (newVal) => {
    source.value = newVal;
}, { immediate: true });
</script>

<template>
    <div class="flex flex-col items-center p-6 bg-white rounded-xl w-full card">
        <template v-if="loading">
            <VLSkeleton width="80%" height="1.25rem" class="mb-4" />
            <VLSkeleton shape="circle" size="12rem" class="mb-4" />
            <VLSkeleton v-if="buttonLabel" width="100%" height="2.75rem" />
        </template>

        <template v-else>
            <label class="mb-4">
                {{ title }}
            </label>

            <div
                class="w-48 h-48 rounded-full flex items-center justify-center bg-gray-50 transition-all duration-300"
            >
                <span class="text-4xl transition-all duration-500">
                    {{ Math.round(animatedCurrent) }}
                </span>
            </div>

            <VButton
                v-if="buttonLabel"
                :label="buttonLabel"
                :type="ButtonType.OUTLINE_SECONDARY"
                :disabled="disabled"
                class="mt-5"
                @click="emit('action')"
            />
        </template>
    </div>
</template>

<style scoped>
.card {
    border: 1px solid var(--secondary-color);
}
</style>
